import api from "../index";

export const getCorporateAccount = () => api.get("corporateaccount/get-corporate-account");
export const getTaxDomicilesReasons = () => api.get("corporateaccount/tax-domiciles-reasons");
export const getNatureOfBusiness = () => api.get("corporateaccount/nature-of-business");

export const getCompanyInfo = (id) => api.get(`corporateaccount/get-companyinfo/${id}`);
export const addUpdateCompanyInfo = (data) => api.post("corporateaccount/add-update-companyinfo", data);

export const getRepresentativeInfoApi = (id) => api.get(`/CorporateAccount/get-representativeinfo/${id}`);
export const AddUpdateRepresentativeInfoApi = (data) => api.post('/CorporateAccount/add-update-representativeinfo', data, { headers: { 'Content-Type': 'multipart/form-data' } });

export const getFinancialInfo = (id) => api.get(`corporateaccount/get-financialinfo/${id}`);
export const addUpdateFinancialInfo = (data) => api.post("corporateaccount/add-update-financialinfo", data);

export const addUpdateBeneficialInfo = (data) => api.post("/CorporateAccount/add-update-beneficialinfo", data, { headers: { 'Content-Type': 'multipart/form-data' } });
export const getAllBeneficialInfoApi = () => api.get(`/CorporateAccount/user/get-all-beneficialinfo`);
export const getBeneficialInfoApi = (id) => api.get(`/CorporateAccount/get-beneficialinfo/${id}`);
export const deleteBeneficialInfoApi = (id) => api.delete(`/CorporateAccount/remove-beneficialinfo/${id}`);

export const AddUpdateDirectorsShareholdersApi = (data) =>
  api.post("/CorporateAccount/add-update-directorinfo", data);
export const getAllDirectorsShareholdersApi = () => api.get(`/CorporateAccount/user/get-all-directorinfo`);
export const getDirectorsShareholdersApi = (id) => api.get(`/CorporateAccount/get-directorinfo/${id}`);
export const deleteDirectorsShareholdersApi = (id) => api.delete(`/CorporateAccount/remove-directorinfo/${id}`);

export const getDocuments = (id) => api.get(`corporateaccount/get-corporate-documents/${id}`);
export const addUpdateDocuments = (data) => api.post("corporateaccount/add-update-corporate-documents", data, { headers: { 'Content-Type': 'multipart/form-data' } });

export const addUpdateCorporateDeclaration = (data) => api.post("CorporateAccount/set-declarationinfo", data);
export const getCorporateDeclarationInfo = (userId) =>
  api.get("CorporateAccount/get-declarationinfo", { params: userId ? { userId } : undefined });

